<div class="container" fxLayout="column" fxLayoutAlign="space-between center">
  <div class="body" style="text-align: center" *ngIf="!errors">
    <div class="row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="center center" fxLayoutGap="16px">
      <app-currency #left
                    class="currency-field"
                    [header]="'Card Currency'"
                    [currencies]="sourceCurrencies"
                    (amountChanged)="leftValueChanged($event)"
                    (currencyChanged)="leftCurrencyChanged($event)"
                    [rate]="sourceRate"
                    [otherCurrency]="rightCurrency"
                    (clearOtherCurrency)="clearRight()"></app-currency>
      <!--    <span class="equals-sign">=</span>-->
<!--      <mat-icon class="equals-sign" [ngClass]="{'reverse': !direction}" [ngClass.lt-md]="{vertical: true, 'reverse': !direction}">arrow_forward</mat-icon>-->
      <img class="equals-sign" src="assets/arrow_forward-24px.svg" [ngClass]="{'reverse': false}" [ngClass.lt-md]="{vertical: true, 'reverse': false}"/>
      <app-currency #right
                    class="currency-field"
                    [header]="'Destination/Local Currency'"
                    [currencies]="destinationCurrencies"
                    (amountChanged)="rightValueChanged($event)"
                    (currencyChanged)="rightCurrencyChanged($event)"
                    [rate]="destinationRate"
                    [otherCurrency]="leftCurrency"
                    (clearOtherCurrency)="clearLeft()"></app-currency>
    </div>
  </div>
  <div class="body" style="text-align: center"  *ngIf="errors && !busy">
    <p class="description">The spend calculator has encountered an error.
      <br/>Please try again later or contact Travelex.
    </p>
  </div>
  <mat-progress-bar color="accent" mode="indeterminate" *ngIf="busy"></mat-progress-bar>
</div>
